

export const UserPermissionRoles = [
    { name: "User", value: "user" },
    { name: "Admin", value: "admin" },
];
